import React, { useEffect } from 'react';
import { Button, Form, Input, Space, Switch, Tooltip, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../../shared/i18n';
import tmService from '../../../services/tmService';
import { ok, toastErr } from './common';

/** 通用设置（所有类型）：名称、打开/点击追踪默认值（发信时 track_opens / track_clicks 可逐封覆盖） */
const Settings = ({ stream, onSaved }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [saving, setSaving] = React.useState(false);

    useEffect(() => {
        form.setFieldsValue({ name: stream.name, track_opens: !!stream.track_opens, track_clicks: !!stream.track_clicks });
    }, [stream, form]);

    const save = async () => {
        const v = await form.validateFields();
        setSaving(true);
        try {
            const r = await tmService.updateStream(stream.id, { name: v.name.trim(), track_opens: v.track_opens, track_clicks: v.track_clicks });
            if (ok(r)) { message.success(t('Saved')); onSaved && onSaved(r.data); }
        } catch (e) {
            toastErr(e, t('Failed to save'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Form form={form} layout="vertical" style={{ maxWidth: 640 }}>
            <Form.Item name="name" label={t('Name')}
                rules={[{ required: true, message: t('Enter a name') }, { pattern: /^[\p{L}\p{N} ._-]{1,64}$/u, message: t('1–64 characters (letters, digits, spaces, . _ -)') }]}>
                <Input maxLength={64} style={{ maxWidth: 320 }} />
            </Form.Item>
            <Space size={24} wrap>
                <Form.Item name="track_opens" valuePropName="checked"
                    label={<Space size={4}>{t('Open tracking')}<Tooltip title={t('Default; set track_opens per message to override')}><QuestionCircleOutlined /></Tooltip></Space>}>
                    <Switch />
                </Form.Item>
                <Form.Item name="track_clicks" valuePropName="checked"
                    label={<Space size={4}>{t('Click tracking')}<Tooltip title={t('Default; set track_clicks per message to override')}><QuestionCircleOutlined /></Tooltip></Space>}>
                    <Switch />
                </Form.Item>
            </Space>
            <div><Button type="primary" loading={saving} onClick={save}>{t('Save')}</Button></div>
        </Form>
    );
};

export default Settings;
